import React from 'react';
import { useNavigate } from 'react-router-dom';
import useStore from '../../store';
import './Header.css';

export default function Header() {
  const { user, toggleSidebar, toggleMobileNav } = useStore();
  const navigate = useNavigate();

  const initials = user
    ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase()
    : 'U';

  const today = new Date().toLocaleDateString('en-IN', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });

  // Below the mobile breakpoint the sidebar is an off-canvas drawer (opened/
  // closed via mobileNavOpen); above it, the same button collapses the
  // sidebar to an icon rail (sidebarCollapsed) instead.
  const handleMenuClick = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      toggleMobileNav();
    } else {
      toggleSidebar();
    }
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="header-menu-btn" onClick={handleMenuClick} aria-label="Toggle sidebar">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>
        <span className="header-date">{today}</span>
      </div>

      <div className="header-right">
        <div className="header-role-badge">
          <span className="badge badge-violet capitalize">
            {user?.role}
          </span>
          {user?.employee_type === 'contractor' && (
            <span className="badge badge-amber" style={{ marginLeft: 6 }}>Contractor</span>
          )}
        </div>

        <button
          className="header-profile-btn"
          onClick={() => navigate('/profile')}
          aria-label="View profile"
        >
          <div className="avatar avatar-md" style={{ background: 'var(--brand-violet)' }}>
            {user?.avatar_url
              ? <img src={user.avatar_url} alt="" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
              : initials
            }
          </div>
          {/* <div className="header-profile-info">
            <span className="header-profile-name">{user?.first_name} {user?.last_name}</span>
          </div> */}
        </button>
      </div>
    </header>
  );
}
